import React from 'react';
import NavigateButton from 'shared/modules/grade-scale/grade-range/navigate-button/component';

export default class LeftNavigateButton extends React.PureComponent<{ onClick: () => void }> {
	render() {
		return <NavigateButton className='left' onHoverMessage='Prev Test' onClick={()=> this.props.onClick()} />;
	}
}